<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>ការគ្រប់គ្រងប្រតិបត្តិការ</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
						<div class="md-layout">
							<div class="md-layout-item md-small-size-50 md-size-20">
								<md-checkbox v-model="refresh">ធ្វើបច្ចុប្បន្នភាពជាប្រចាំ</md-checkbox>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-30">
								<md-field>
									<label>{{translate(locale.searchUser)}}</label>
									<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-25">
								<md-field>
									<label>{{translate(locale.status)}}</label>
									<md-select :placeholder="translate(locale.statusAll)" v-model="search.status">
										<md-option value="">{{translate(locale.all)}}</md-option>
										<md-option value="1">បានបង់ប្រាក់</md-option>
										<md-option value="0">មិនទាន់បង់ប្រាក់</md-option>
										<md-option value="2">ផុតកំណត់</md-option>
									</md-select>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-25">
								<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">{{translate(locale.search)}}</md-button>
							</div>
							
						</div>
						<md-table v-if="paymentList.length > 0">
							<md-table-row>
								<md-table-head></md-table-head>
								<md-table-head>លេខកូដប្រតិបត្តិការ</md-table-head>
								<md-table-head>អ្នកប្រើប្រាស់</md-table-head>
								<!-- <md-table-head>ប្រតិបត្តិការ</md-table-head> -->
								<md-table-head>ប្រភេទបង់ប្រាក់</md-table-head>
								<md-table-head>ចំនួនទឹកប្រាក់</md-table-head>
								<md-table-head>{{translate(locale.status)}}</md-table-head>
								<md-table-head>ថ្ងៃបង្កើត</md-table-head>
								<!-- <md-table-head>{{translate(locale.action)}}</md-table-head> -->
							</md-table-row>

							<md-table-row v-for="(payment, index) in paymentList">
								<md-table-cell>​{{ index + 1 }}</md-table-cell>
								<md-table-cell><b>{{payment.hash}}</b><br><span class="khqr_md5">{{payment.khqr_md5 || "N/A"}}</span></md-table-cell>
								<md-table-cell>
									<b>{{payment.name}}</b> ({{String(payment.username).slice(0,12)}})<br>
									<template v-if="payment.paid == 1">បង់ប្រាក់ជោគជ័យក្នុង {{((new Date(payment.paid_date)).getTime()/ 1000) - payment.created_date}} វិនាទី</template>
									<template v-else>មិនទាន់ជោគជ័យ</template>
								</md-table-cell>
								<!-- <md-table-cell>
									<span v-if="payment.title">រឿង៖ {{payment.title}}</span>
									<span v-if="payment.plan_name">គម្រោង៖ {{payment.plan_name.split("||")[1]}}</span>
								</md-table-cell> -->
								<md-table-cell>
									<span class="green">{{config.getPayment(payment.type)}}</span> 
									<span v-if="payment.title"> {{payment.title}}</span>
									<span v-if="payment.plan_name"> {{payment.plan_name.split("||")[1]}}</span>
									<span v-if="payment.type == 'topup'"> {{config.moneylify(payment.amount)}}</span>
								</md-table-cell>
								<md-table-cell><b>{{config.moneylify(payment.amount)}}</b><br>{{config.getProvider(payment.provider)}}</md-table-cell>	
								<md-table-cell>
									<span class="yellow" v-if="payment.paid == 0">មិនទាន់បង់ប្រាក់</span>
									<span class="green" v-if="payment.paid == 1">បានបង់ប្រាក់</span>
									<span class="red" v-if="payment.paid == 2">ផុតកំណត់</span>
								</md-table-cell>
								<md-table-cell><b>{{config.datelify(payment.created_date)[1]}}</b> <br>({{config.getAge(payment.created_date)[1]}})</md-table-cell>
								<md-table-cell>
									<md-button class="md-just-icon md-simple md-danger" @click="checkTransaction(payment.hash)" v-if="payment.provider == 'bakong' && payment.paid == 0">
										<md-icon>published_with_changes</md-icon>
										<md-tooltip md-direction="top">ផ្ទៀងផ្ទាត់ឡើងវិញ (Bakong)</md-tooltip>
									</md-button>
									<md-button class="md-just-icon md-simple md-success" @click="onConfirm(payment.hash)" v-if="payment.paid == 0">
										<md-icon>verified</md-icon>
										<md-tooltip md-direction="top">អនុម័តការបង់ប្រាក់</md-tooltip>
									</md-button>
								</md-table-cell>
							</md-table-row>
						</md-table>
						<h5 class="text-center" v-if="paymentList.length == 0 && loaded == true">មិនមានប្រតិបត្តិការ ។</h5>
						<div class="text-right" v-if="loadMore">
							<md-button class="md-primary" @click="searchHandler(true)">{{translate(locale.showMore)}}</md-button>
						</div>
					</div>
					<md-dialog-confirm :md-active.sync="confirmDialogActive"
						:md-title="'បញ្ជាក់ថាបានទូទាត់ ?'"
						:md-cancel-text="translate(locale.cancel)" @md-cancel="onCancel" @md-confirm="onConfirm" />
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>
	export default {
		created() {
			this.searchHandler();
			this.interval = setInterval(() => {
				if(this.refresh== 'on') {
					this.searchHandler();
				}
			}, 10000)
		},
		beforeDestroy() {
			clearInterval(this.interval);
		},
		data() {
			return {
				loaded: false,
				confirmDialogActive: false, confirmSelected: '',
				search: { text: "", status: ""},
				loadMore: false,
				paymentList: [],
				interval: null,
				refresh: ""
			}
		},
		methods: {
			searchHandler(more = false) {
				let size = 50;
				this.$http.post(this.config.api + "/user/payment/search", {
					text: this.search.text,
					status: this.search.status,
					size: size,
					offset: more ? this.paymentList.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == size) this.loadMore = true;
					else this.loadMore = false;
					this.paymentList = more ? this.paymentList.concat(data.body.data) : data.body.data;
				})
			},
			checkTransaction(hash) {
				this.$http.post(this.config.api + "/user/payment/check", {
					hash: hash,
				}).then(data => {
					if (data.body.status == 'success') {
						this.$notification.notify({ message: "បង់ប្រាក់បានជោគជ័យ", icon: 'check_circle', type: 'success' });
						this.searchHandler();
					}
				})
			},
			onConfirm(hash) {

				if (this.confirmSelected == "") {
					this.confirmDialogActive = true;
					this.confirmSelected = hash;
					return;
				}

				this.$http.post(this.config.api + "/user/payment/confirm", {
					hash: this.confirmSelected
				}).then(res => {
					this.onCancel();
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "អ្នកបានអនុម័យការទូទាត់ប្រាក់ដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
					}
				})
			},
			onCancel() {
				this.confirmSelected = ""
				this.confirmDialogActive = false
			}
		}
	}
</script>
<style >
	.khqr_md5 {
		font-size: 8px;
	}
	.check-transaction {
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Payments/View.vue